"use client";

// French wrapper for the hub tutorial video (FR-1). The videos are in
// English; this asks YouTube to show French captions when the video has them.
import React from "react";
import { StyledDiv } from "../widgetVideoGuide/widgetVideoGuide.styles";
import { IPlugin } from "../../types";

function getYoutubeEmbedUrl(url: string): string | null {
  if (!url) return null;
  if (url.includes("youtube.com/watch?v=")) {
    const id = url.split("v=")[1]?.split("&")[0];
    return id ? `https://www.youtube.com/embed/${id}` : null;
  }
  if (url.includes("youtu.be/")) {
    const id = url.split("youtu.be/")[1]?.split("?")[0];
    return id ? `https://www.youtube.com/embed/${id}` : null;
  }
  if (url.includes("youtube.com/embed/")) return url.split("?")[0];
  return null;
}

export const WidgetVideoGuideFr = ({ widget }: { widget: IPlugin }) => {
  const embedUrl = getYoutubeEmbedUrl(widget.videoUrl || "");
  if (!embedUrl) return null;
  return (
    <StyledDiv className="static">
      <div className="video-container">
        <iframe
          src={`${embedUrl}?hl=fr-FR&cc_lang_pref=fr&cc_load_policy=1`}
          title={`Tutoriel\u00a0: ${widget.name} (vidéo en anglais)`}
          width="100%"
          height="auto"
          style={{ maxWidth: "930px", borderRadius: "10px", minHeight: "315px", border: "none" }}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </StyledDiv>
  );
};
